import { useAuth } from "react-oidc-context";
import { UidNumber } from "tng-address-collection-shared/types/primitives.ts";

export const useUserUidNumber = (): number | undefined => {
  const { user } = useAuth();

  const uidNumberRaw =
    user?.profile?.["custom:uid_number"] ?? user?.profile?.["uidNumber"];

  if (typeof uidNumberRaw !== "string") return undefined;

  const uidNumber = parseInt(uidNumberRaw, 10);
  return UidNumber.safeParse(uidNumber).data;
};
